import React from 'react'
import Dropdown from '../../../../sharedComponent/Dropdown/Dropdown'
import Tooltip from '../../../../sharedComponent/CustomTooltip/Tooltip'

const InputField = ({label, name, formik, tooltiptext,isEditable}: any) => {

  return(
  <div className='mr-0 ml-0 p-0 pb-5 ps-3 col-md-6 col-sm-6'>
    <div className='fw-bold fs-6 mb-2 mt-4 required d-flex' style={{color: '#5E6278'}}>
      {label}
      <Tooltip text={tooltiptext} isLast={false} textClassName={'text-black fs-7 fw-normal'} />
    </div>
    <input
      type='text'
      className='form-control form-control-solid'
      name={name}
      placeholder={`Enter ${label}`}
      {...formik.getFieldProps(name)}
      disabled={isEditable}
      
      />
    {formik.touched[name] && formik.errors[name] && (
      <div className='fv-plugins-message-container'>
        <div data-field={name} data-validator='notEmpty' className='fv-help-block'>
          {formik.errors[name]}
        </div>
      </div>
    )}
  </div>
)}

const DropdownField = ({label, fieldName, optionList, formik,isEditable}: any) => {
  const handleSelectedItem = (e: any, name: any) => {
    console.log("=====name,",name)
    if (e.value.length > 0) {
      formik.setFieldValue(`${name}Id`, e.value)
      formik.setFieldValue(name, e.label)
    } else {
      formik.setFieldValue(`${name}Id`, null)
      formik.setFieldValue(name, '')
    }
  }
  return( <div className='mr-0 ml-0 p-0 pb-5 ps-3 col-md-6 col-sm-6'>
    <div className='fw-bold fs-6 mb-2 mt-4 required' style={{color: '#5E6278'}}>
      {label}
    </div>
    <Dropdown
      fieldName={fieldName}
      optionList={optionList}
      handleSelectedItem={handleSelectedItem}
      formik={formik}
      className='bg-white'
      fieldDisabled={isEditable}
    />
  </div>)
}
 


export const DynamicElectricProduct = ({formik, brands,productDetails}: any) => {
  console.log("=====ebrands",brands)


  return(
  <>
    <div className='mt-7 d-flex align-items-end  no-gutters noPadding row'>
      <InputField
        label='E_Rate'
        name='rate'
        formik={formik}
        tooltiptext={`minimum value is ${productDetails?.rateMinimum} and maximum value is ${productDetails?.rateMaximum}`}
        isEditable={productDetails.isEditable}
      />
      <DropdownField label='E_Brand' fieldName='brand' optionList={brands} formik={formik} isEditable={productDetails.isEditable}
      />
    </div>
    <div className=' d-flex align-items-end no-gutters noPadding row'>
      <InputField
        label='E_Term'
        name='term'
        formik={formik}
        tooltiptext={`minimum value is ${productDetails?.termMinimum} and maximum value is ${productDetails?.termMaximum}`}
        isEditable={productDetails.isEditable}

      />
    </div>
  </>
)}

export const DynamicGasProduct = ({formik, brands,productDetails}: any) => {
  console.log("=====gbrands",brands)
  return(
  <>
    <div className='mt-7 d-flex align-items-end  no-gutters noPadding row'>
      <InputField
        label='G_Rate'
        name='grate'
        formik={formik}
        tooltiptext={`minimum value is ${productDetails?.grateMinimum} and maximum value is ${productDetails?.grateMaximum}`}
        isEditable={productDetails.isEditable}

      />
      <DropdownField label='G_Brand' fieldName='gbrand' optionList={brands} formik={formik}         isEditable={productDetails.isEditable}
      />
    </div>
    <div className=' d-flex align-items-end  no-gutters noPadding row'>
      <InputField
        label='G_Term'
        name='gterm'
        formik={formik}
        tooltiptext={`minimum value is ${productDetails?.gtermMinimum} and maximum value is ${productDetails?.gtermMaximum}`}
        isEditable={productDetails.isEditable}

      />
    </div>
  </>
)}
